/**
 * display content  on the page in a dialog.
 *
 * @requires TweenLite
 * @requires TweenLiteCSS
 */

define('libs/dialog',['require','libs/utilities.element.getdimensions','TweenLite','TweenLiteCSS'],function(require) {

    'use strict';

    var _getDimensions = require('libs/utilities.element.getdimensions'),
        _tween = require('TweenLite'),
        _tween_css = require('TweenLiteCSS');

    var SETTINGS = {
        rootSelector: '.dialog',
        pageContentSelector: '.page-content',
        dialogContentSelector: '.dialog__content',
        closeButtonSelector: '.close',
        animationTime: .5,
        destroyOnHide: true,
        disablePageScroll: false,
        centered: true
    };

    var EVENTS = {
        showComplete: 'Dialogs.showComplete'
    };

    /**
     * @class Dialog
     * @param {Element} root The root element for the dialog.
     * @param {Object} settings The settings for the dialog.
     */
    var Dialog = function(root, settings) {
        this.root = root;
        this.$root = $(root);
        this.settings = $.extend({}, SETTINGS, settings || {});

        this.showing = false;

        $(window).on('resize', this.resizeHandler.bind(this));

        this.prepareComponents();
    };

    /**
     * Show the dialog.
     * @memberof Dialog
     */
    Dialog.prototype.show = function(event, delayed) {

        // generic failsafe
        if (this.showing) {
            return;
        }

        // show is called immediately after the dialogify-link was clicked and
        // the dialog was created. in case of an ajax dialog however, the actual
        // show will be postponed until the dialog was loaded. the 'delayed' argument
        // should be cached in this situation as the second call to 'show' won't have
        // access to the original value.
        if (!this.root) {
            this.delayedCache = delayed;
            return;
        }
        if (delayed === undefined) {
            delayed = this.delayedCache;
        }

        // Put a 'showing' flag up. This flag can be used for
        // instances to check before executing some functionality
        // like auto center on window resize. (handlers are always
        // triggered, even when dialog is hidden)
        this.showing = true;

        // animate the dialog.
        _tween.fromTo(this.root, this.settings.animationTime, {
            display: 'block',
            opacity: 0
        }, {
            opacity: 1,
            delay: delayed ? this.settings.animationTime : 0,
            onComplete: function() {
                this.$root.trigger(EVENTS.showComplete, {
                    type: EVENTS.showComplete,
                    target: this.$root
                });
            }.bind(this)
        });

        // position the dialog
        this.updatePosition(event);
    };

    /**
     * Hide and destroy the dialog.
     * @memberof Dialog
     */
    Dialog.prototype.hide = function() {
        if (!this.showing) {
            return;
        }

        // put showing flag down
        this.showing = false;

        // animate the dialog. on complete destroy if needed.
        _tween.to(this.root, this.settings.animationTime, {
            opacity: 0,
            display: 'none',
            onComplete: function() {
                if (this.settings.destroyOnHide) {
                    this.destroy();
                }
            }.bind(this)
        });

        // re-enable scrolling on the page
        if (this.settings.disablePageScroll) {
            $('html').css('overflow', '');
        }
    };

    /**
     * On resize, trigger the this.updatePosition function. Debounced to prevent
     * overload of the browser's layout cycle
     */
    Dialog.prototype.resizeHandler = function() {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        // don't continue if we're not actually showing.
        if (!this.showing) {
            return;
        }
        this.resizeTimeout = setTimeout(function() {
            this.updatePosition();
        }.bind(this), 250); // 250 ms debounce.
    };

    Dialog.prototype.updatePosition = function() {console.log('Dialog.prototype.updatePosition', this)
        if (this.settings.centered) {
            if ((document.documentElement || document.body).clientWidth <= 800/*_global.VIEWPORT.DESKTOP*/) { //1024
                this.positionForMobile();
            }
            else {
                this.positionOnCenter();
            }
        }
        //else {
        //    if (event) {
        //        this.positionTarget = event.currentTarget;
        //    }
        //    this.positionOnTarget(this.positionTarget);
        //}

        // disable scrolling on the page if settings demand && screen is large enough.
        if (this.settings.disablePageScroll && (document.documentElement || document.body).clientWidth > 800) {
            $('html').css('overflow', 'hidden');
        }
        else {
            $('html').css('overflow', '');
        }
    };

    /**
     * Center the dialog in the viewport.
     * @memberof Dialog
     */
    Dialog.prototype.positionOnCenter = function() {
        var dialogDimensions = _getDimensions(this.root);

        // left and top should be half of difference between window width/height
        // and dialog width/height.
        this.$root.css({
            position: ''
        });
        this.$root.css({
            top: ((document.documentElement || document.body).clientHeight - dialogDimensions.height) / 2,
            left: ((document.documentElement || document.body).clientWidth - dialogDimensions.width) / 2
        });
    };

    /**
     * position dialog at top of current viewport
     */
    Dialog.prototype.positionForMobile = function() {
        this.$root.css({
            position: 'absolute'
        });
        this.$root.css({
            top: $(window).scrollTop(),
            left: 0
        });
    };

    //Dialog.prototype.positionOnTarget = function(target) {
    //    if (!target) {
    //        return;
    //    }
    //    var target_pos = _position.get(target),
    //        target_rect = _getDimensions(target),
    //        dialog_rect = _getDimensions(this.root);
    //
    //    var calculated_pos = {
    //        top: target_pos.top - dialog_rect.height,
    //        left: target_pos.left - (dialog_rect.width / 2) + (target_rect.width / 2)
    //    };
    //
    //    if (calculated_pos.left + dialog_rect.innerWidth > window.innerWidth - 16) {
    //        calculated_pos.left = window.innerWidth - dialog_rect.innerWidth - 16;
    //    }
    //    if (calculated_pos.left < 16) {
    //        calculated_pos.left = 16;
    //    }
    //
    //    _position.set(this.root, calculated_pos);
    //};

    /**
     * Remove the dialog from the dom.
     */
    Dialog.prototype.destroy = function() {
        this.$root.remove();
    };

    /**
     * Prepare the dialog content
     */
    Dialog.prototype.prepareComponents = function() {

        if (!this.root) return;

        // do stuff in the dialog.

    };

    Dialog.EVENTS = EVENTS;

    return Dialog;
});

